import {ChangeDetectorRef, Component, forwardRef, OnInit} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DepotService} from "../../services/depot-service/depot.service";
import {appInjector} from "../../../index";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";

@Component({
  selector: 'vb-depot-form',
  templateUrl: './depot-form.component.html',
  styleUrls: ['./depot-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => DepotFormComponent)}]
})
export class DepotFormComponent extends AbstractVisbosControl<Depot, FormGroup> implements OnInit {

  public setDefaultValues(item?: Depot): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      administration_unit_id: this.setValue(item, 'administration_unit.cuid', this.ngRx.getState().session.activeAdminUnit),
      auto_order_proposals_enabled: this.setValue(item, 'auto_order_proposals_enabled', false),
    };
  }

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, private depotService: DepotService, private ngRx: NgRedux<IAppState>) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(values?: Depot): FormGroup {
    return DepotFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      name: [null, Validators.required],
      description: [null],
      auto_order_proposals_enabled: [false],
      ean: [null]
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/depot/depot-form/depot-form.component.ts